<template>
  <generic-modal
    :title="$t('view debt case')"
    ref="generic_modal"
    size="fullscreen"
  >
    <div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("nominal salary") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.nominal_salary" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="title">
            {{ format_currency(liquid_salary) }}
          </div>
          <div class="subtitle">
            {{ $t("liquid salary") }}
          </div>
        </div>
        <div class="column">
          <div class="title">
            {{ format_currency(liquid_minus_debt) }}
          </div>
          <div class="subtitle">
            {{ $t("liquid salary minus debt") }}
          </div>
        </div>
      </div>
      <div class="table-container">
        <table class="table is-fullwidth is-narrow is-hoverable is-striped">
          <thead>
            <tr>
              <th></th>
              <th>{{ $t("entity") }}</th>
              <th>{{ $t("quota") }}</th>
              <th>{{ $t("original capital") }}</th>
              <th>{{ $t("term in months") }}</th>
              <th>{{ $t("annual rate") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itm, index) in meta.prestamos" :key="index">
              <td
                :rowspan="meta.prestamos.length"
                class="is-success rotate-wrapper"
                v-if="index == 0"
              >
                <div class="rotate">Préstamo</div>
              </td>
              <td>
                {{ itm.entidad }}
              </td>
              <td>{{ format_currency(itm.quota) }}</td>
              <td>{{ format_currency(itm.capital_original) }}</td>
              <td>{{ itm.plazo || "" }}</td>
              <td>{{ itm.tasa_anual ? itm.tasa_anual * 100 + "%" : "" }}</td>
            </tr>
            <tr v-for="(itm, index) in meta.tarjetas" :key="index">
              <td
                :rowspan="meta.tarjetas.length"
                class="is-warning rotate-wrapper"
                v-if="index == 0"
              >
                <div class="rotate">Tarjeta</div>
              </td>
              <td>
                {{ itm.entidad }}
              </td>
              <td>{{ format_currency(itm.quota) }}</td>

              <td>{{ format_currency(itm.saldo_capital) }}</td>
              <td>{{ itm.plazo || "" }}</td>
              <td>{{ itm.tasa_anual ? itm.tasa_anual * 100 + "%" : "" }}</td>
            </tr>
            <tr v-for="(itm, index) in meta.extras" :key="index">
              <td
                :rowspan="meta.extras.length"
                class="is-info rotate-wrapper"
                v-if="index == 0"
              >
                <div class="rotate">Extra</div>
              </td>
              <td>
                {{ itm.entidad }}
              </td>
              <td>{{ format_currency(itm.quota) }}</td>
              <td>{{ format_currency(itm.capital_original) }}</td>
              <td>{{ itm.plazo || "" }}</td>
              <td>{{ itm.tasa_anual * 100 + "%" }}</td>
            </tr>
            <tr v-for="(itm, index) in meta.hipotecas" :key="index">
              <td
                :rowspan="meta.hipotecas.length"
                class="is-success rotate-wrapper"
                v-if="index == 0"
              >
                <div class="rotate">Hipotecas</div>
              </td>
              <td>
                {{ itm.entidad }}
              </td>
              <td>{{ format_currency(itm.quota) }}</td>
              <td>{{ format_currency(itm.capital_original) }}</td>
              <td>{{ itm.plazo || "" }}</td>
              <td>{{ itm.tasa_anual ? itm.tasa_anual * 100 + "%" : "" }}</td>
            </tr>
            <tr v-for="(itm, index) in meta.no_definidos" :key="index">
              <td
                :rowspan="meta.no_definidos.length"
                class="is-primary rotate-wrapper"
                v-if="index == 0"
              >
                <div class="rotate">No definido</div>
              </td>
              <td>{{ itm.entidad }} ({{ itm.tipo_activo }})</td>
              <td></td>
              <td>{{ format_currency(itm.capital_original) }}</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="columns">
        <div class="column">
          <div class="title">{{ format_currency(total_capital) }}</div>
          <div class="subtitle">
            {{ $t("total capital") }}
          </div>
        </div>
        <div class="column">
          <div class="title">
            {{ format_currency(total_quota) }}
          </div>
          <div class="subtitle">
            {{ $t("total quota") }}
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="title">{{ format_currency(total_tarjetas) }}</div>
          <div class="subtitle">
            {{ $t("credit card total") }}
          </div>
        </div>
        <div class="column">
          <div class="title">{{ format_currency(total_prestamos) }}</div>
          <div class="subtitle">
            {{ $t("loan total") }}
          </div>
        </div>
        <div class="column">
          <div class="title">{{ format_currency(total_extras) }}</div>
          <div class="subtitle">
            {{ $t("extrafinancing total") }}
          </div>
        </div>
        <div class="column">
          <div class="title">{{ format_currency(total_hipotecas) }}</div>
          <div class="subtitle">
            {{ $t("mortgage total") }}
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="title">{{ format_currency(cuota_tarjetas) }}</div>
          <div class="subtitle">
            {{ $t("credit card quota") }}
          </div>
        </div>
        <div class="column">
          <div class="title">{{ format_currency(cuota_prestamos) }}</div>
          <div class="subtitle">
            {{ $t("loan quota") }}
          </div>
        </div>
        <div class="column">
          <div class="title">{{ format_currency(cuota_extras) }}</div>
          <div class="subtitle">
            {{ $t("extrafinancing quota") }}
          </div>
        </div>
        <div class="column">
          <div class="title">{{ format_currency(cuota_hipotecas) }}</div>
          <div class="subtitle">
            {{ $t("mortgage quota") }}
          </div>
        </div>
      </div>

      <!-- <pre>{{ meta }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_currency,
  format_date_time,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import moment from "moment";
import { groupBy } from "lodash";

export default {
  name: "ViewModal",
  components: { GenericModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    total_capital() {
      let v = this;
      let prestamos = 0;
      let tarjetas = 0;
      let extras = 0;
      let no_definidos = 0;

      if (v.meta.prestamos) {
        prestamos = v.meta.prestamos.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      }
      if (v.meta.tarjetas) {
        tarjetas = v.meta.tarjetas.reduce(
          (sum, item) => sum + item.saldo_capital,
          0
        );
      }
      if (v.meta.extras) {
        extras = v.meta.extras.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      }
      if (v.meta.no_definidos) {
        no_definidos = v.meta.no_definidos.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      }

      return prestamos + tarjetas + extras + no_definidos;
    },
    total_quota() {
      let v = this;
      let prestamos = 0;
      let tarjetas = 0;
      let extras = 0;
      let no_definidos = 0;
      if (v.meta.prestamos) {
        prestamos = v.meta.prestamos.reduce((sum, item) => sum + item.quota, 0);
      }
      if (v.meta.tarjetas) {
        tarjetas = v.meta.tarjetas.reduce((sum, item) => sum + item.quota, 0);
      }
      if (v.meta.extras) {
        extras = v.meta.extras.reduce((sum, item) => sum + item.quota, 0);
      }
      // if (v.meta.no_definidos) {
      //   no_definidos = v.meta.no_definidos.reduce(
      //     (sum, item) => sum + item.quota,
      //     0
      //   );
      // }
      return prestamos + tarjetas + extras /* + no_definidos */;
    },
    liquid_salary() {
      let v = this;
      if (v.meta.nominal_salary) return v.meta.nominal_salary * 0.9;
      else return 0;
    },
    liquid_minus_debt() {
      let v = this;
      return v.liquid_salary - v.total_quota;
    },
    total_tarjetas() {
      let v = this;
      if (v.meta.tarjetas) {
        return v.meta.tarjetas.reduce(
          (sum, item) => sum + item.saldo_capital,
          0
        );
      } else return 0;
    },
    total_prestamos() {
      let v = this;
      if (v.meta.prestamos) {
        return v.meta.prestamos.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      } else return 0;
    },
    total_extras() {
      let v = this;
      if (v.meta.extras) {
        return v.meta.extras.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      } else return 0;
    },
    total_hipotecas() {
      let v = this;
      if (v.meta.hipotecas) {
        return v.meta.hipotecas.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      } else return 0;
    },
    cuota_tarjetas() {
      let v = this;
      if (v.meta.tarjetas) {
        return v.meta.tarjetas.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    cuota_prestamos() {
      let v = this;
      if (v.meta.prestamos) {
        return v.meta.prestamos.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    cuota_extras() {
      let v = this;
      if (v.meta.extras) {
        return v.meta.extras.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    cuota_hipotecas() {
      let v = this;
      if (v.meta.hipotecas) {
        return v.meta.hipotecas.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
  },
  methods: {
    pmt(rate, nper, pv) {
      if (rate === 0) return -(pv / nper);
      const factor = Math.pow(1 + rate, nper);
      return -(pv * rate * factor) / (factor - 1);
    },
    format_currency,
    format_date_time,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/debt-level", { uuid: uuid })
        .then((debt_level) => {
          let data = debt_level.sib_extracted_data;
          if (data && data.detalle) {
            /** Extrafinanciamientos */
            let tc_extra_array = v.module_settings.extrafinancing_identifiers
              ? v.module_settings.extrafinancing_identifiers
                  .split(",")
                  .map((item) => item.trim().toUpperCase())
                  .filter((item) => item)
              : [];
            let extras = data.detalle.filter((item) =>
              tc_extra_array.includes(item.tipo_activo.toUpperCase())
            );
            data.extras = extras.map((item) => {
              let fecha_concesion = item.concesion;
              let fecha_vencimiento = "";
              if (item.vencimiento) {
                fecha_vencimiento = item.vencimiento;
                let term_in_months = moment(
                  fecha_vencimiento,
                  "DD/MM/YYYY"
                ).diff(moment(fecha_concesion, "DD/MM/YYYY"), "months");
                item.plazo = term_in_months.toFixed(0);
                if (item.plazo > 36)
                  item.tasa_anual = 0.2; // 20% annual rate for terms over 36 months
                else item.tasa_anual = 0;
                item.quota =
                  v.pmt(
                    item.tasa_anual / 12,
                    item.plazo,
                    item.capital_original
                  ) * -1;
              }
              return item;
            });

            /** Tarjetas de crédito */
            let tc_array = v.module_settings.credit_card_identifiers
              ? v.module_settings.credit_card_identifiers
                  .split(",")
                  .map((item) => item.trim().toUpperCase())
                  .filter((item) => item)
              : [];
            let tarjetas = data.detalle.filter((item) =>
              tc_array.includes(item.tipo_activo.toUpperCase())
            );
            let grouped_tarjetas = groupBy(tarjetas, "entidad");
            data.tarjetas = Object.keys(grouped_tarjetas).map((key) => {
              let items = grouped_tarjetas[key];
              let total_capital_original = items.reduce(
                (sum, item) => sum + item.capital_original,
                0
              );
              let total_saldo_capital = items.reduce(
                (sum, item) => sum + item.saldo_capital,
                0
              );
              return {
                entidad: key,
                tipo_activo: "TARJETA DE CRÉDITO",
                capital_original: total_capital_original,
                plazo: 60,
                saldo_capital: total_saldo_capital,
                tasa_anual: 0.02, // Assuming a fixed annual rate for all credit cards
                quota: 0.02 * total_saldo_capital,
              };
            });

            /** Prestamos */
            let loan_array = v.module_settings.loan_identifiers
              ? v.module_settings.loan_identifiers
                  .split(",")
                  .map((item) => item.trim().toUpperCase())
                  .filter((item) => item)
              : [];
            let loans = data.detalle.filter((item) =>
              loan_array.includes(item.tipo_activo.toUpperCase())
            );
            data.prestamos = loans.map((item) => {
              item.tasa_anual = 0.2; // Assuming a fixed annual rate for non-credit card debts
              let fecha_concesion = item.concesion;
              let fecha_vencimiento = "";
              if (item.vencimiento) {
                fecha_vencimiento = item.vencimiento;
                let term_in_months = moment(
                  fecha_vencimiento,
                  "DD/MM/YYYY"
                ).diff(moment(fecha_concesion, "DD/MM/YYYY"), "months");
                item.plazo = term_in_months.toFixed(0);
              }
              item.quota =
                v.pmt(item.tasa_anual / 12, item.plazo, item.capital_original) *
                -1;
              return item;
            });

            /** Hipotecas */
            let mortgage_array = v.module_settings.mortgage_identifiers
              ? v.module_settings.mortgage_identifiers
                  .split(",")
                  .map((item) => item.trim().toUpperCase())
                  .filter((item) => item)
              : [];
            let hipotecas = data.detalle.filter((item) =>
              mortgage_array.includes(item.tipo_activo.toUpperCase())
            );
            data.hipotecas = hipotecas.map((item) => {
              item.tasa_anual = 0.2; // Assuming a fixed annual rate for non-credit card debts
              let fecha_concesion = item.concesion;
              let fecha_vencimiento = "";
              if (item.vencimiento) {
                fecha_vencimiento = item.vencimiento;
                let term_in_months = moment(
                  fecha_vencimiento,
                  "DD/MM/YYYY"
                ).diff(moment(fecha_concesion, "DD/MM/YYYY"), "months");
                item.plazo = term_in_months.toFixed(0);
              }
              item.quota =
                v.pmt(item.tasa_anual / 12, item.plazo, item.capital_original) *
                -1;
              return item;
            });

            /** Otros activos */
            let no_definidos = data.detalle.filter(
              (item) =>
                !tc_array.includes(item.tipo_activo.toUpperCase()) &&
                !tc_extra_array.includes(item.tipo_activo.toUpperCase()) &&
                !loan_array.includes(item.tipo_activo.toUpperCase())
            );
            data.no_definidos = no_definidos.map((item) => {
              // item.tasa_anual = 0.2; // Assuming a fixed annual rate for non-credit card debts
              // let fecha_concesion = item.concesion;
              // let fecha_vencimiento = "";
              // if (item.vencimiento) {
              //   fecha_vencimiento = item.vencimiento;
              //   let term_in_months = moment(
              //     fecha_vencimiento,
              //     "DD/MM/YYYY"
              //   ).diff(moment(fecha_concesion, "DD/MM/YYYY"), "months");
              //   item.plazo = term_in_months.toFixed(0);
              // }
              // item.quota =
              //   v.pmt(item.tasa_anual / 12, item.plazo, item.capital_original) *
              //   -1;
              return item;
            });
          }

          v.meta = data;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      // v.uuid = "";
    },
    pmt(rate, nper, pv, fv = 0, type = false) {
      if (rate === 0) return -(pv + fv) / nper;

      const factor = Math.pow(1 + rate, nper);
      let payment = (rate * (pv * factor + fv)) / (factor - 1);

      if (type) {
        payment /= 1 + rate;
      }

      return -payment; // El valor negativo representa un desembolso (como en Excel)
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style>
.rotate {
  /* FF3.5+ */
  -moz-transform: rotate(-90deg);
  /* Opera 10.5 */
  -o-transform: rotate(-90deg);
  /* Saf3.1+, Chrome */
  -webkit-transform: rotate(90deg-);
  /* Standard */
  transform: rotate(-90deg);
  vertical-align: bottom;
}
.rotate-wrapper {
  display: table-cell;
}
</style>
